import { render } from "./Voters.vue?vue&type=template&id=5e85a64c&scoped=true"
import script from "./Voters.vue?vue&type=script&lang=ts"
export * from "./Voters.vue?vue&type=script&lang=ts"

import "./Voters.vue?vue&type=style&index=0&id=5e85a64c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e85a64c"

export default script